import { RouteProp } from "@react-navigation/native";
import { PreloadedQuery } from "react-relay";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";
import { TodoBottomSheetMainScreenQuery } from "./__generated__/TodoBottomSheetMainScreenQuery.graphql";

type TodoBottomSheetStackParamList = {
  main: {
    mode: "edit" | "create";
    todoId: string;
    query: PreloadedQuery<TodoBottomSheetMainScreenQuery>;
  };

  linkProduct: { todoId: string };
};

export type TodoBottomSheetStackScreenProps<
  T extends keyof TodoBottomSheetStackParamList,
> = {
  route: RouteProp<TodoBottomSheetStackParamList, T>;
  navigation: NativeStackNavigationProp<TodoBottomSheetStackParamList, T>;
};

export const TodoBottomSheetStack =
  createNativeStackNavigator<TodoBottomSheetStackParamList>();
